import type { Theme } from '@emotion/react'
import { ChevronRightIcon } from '@moia-dev/pace-icons'
import { Icon, Text } from '@moia-dev/pace-web'
import type { CommandPaletteItem } from '../types'

type CommandPaletteResultItemProps = {
  item: CommandPaletteItem
  isSelected: boolean
  onClick: (openInNewTab: boolean) => void
  onMiddleClick: () => void
  ref?: React.Ref<HTMLDivElement>
}

export const CommandPaletteResultItem = ({
  item,
  isSelected,
  onClick,
  onMiddleClick,
  ref,
}: CommandPaletteResultItemProps) => (
  <div
    ref={ref}
    onClick={event => onClick(event.shiftKey || event.metaKey || event.ctrlKey)}
    onAuxClick={event => {
      if (event.button === 1) {
        event.preventDefault()
        onMiddleClick()
      }
    }}
    css={(theme: Theme) => ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: `${theme.space.Space2} ${theme.space.Space3}`,
      cursor: 'pointer',
      borderRadius: theme.radius.RadiusMedium,
      backgroundColor: isSelected
        ? theme.semantic.ColorSurfaceHovered
        : 'transparent',
      transition: 'background-color 120ms ease, transform 80ms ease',
      transform: isSelected ? 'scale(1.005)' : 'scale(1)',

      '&:hover': {
        backgroundColor: theme.semantic.ColorSurfaceHovered,
      },
    })}
  >
    <div
      css={(theme: Theme) => ({
        display: 'flex',
        flexDirection: 'column',
        gap: theme.space.Space0,
      })}
    >
      <Text size="md" weight="emphasized">
        {item.label}
      </Text>
      {item.sectionLabel && (
        <Text size="sm" color="reduced">
          {item.sectionLabel}
        </Text>
      )}
    </div>
    <div
      css={(theme: Theme) => ({
        display: 'flex',
        alignItems: 'center',
        color: theme.semantic.ColorContentReduced,
        opacity: isSelected ? 1 : 0,
        transition: 'opacity 120ms ease',
      })}
    >
      <Icon
        size={20}
        css={theme => ({ color: theme.semantic.ColorContentReduced })}
      >
        <ChevronRightIcon />
      </Icon>
    </div>
  </div>
)
